




import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'ScaIndex' })
export default class Index extends Vue {}
